export default __webpack_public_path__ + "media/images/logo-d8eeab14e5883f8ae1890cd92c32a12a.svg";